import { Injectable } from '@angular/core';
import {StepKey} from '../../../enums/step-key.enum';
import {isKIOSKPOLIS, isNext} from '../../../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class InternalStepsConfigService {

  isNext = isNext();

  private readonly CONFIG: InternalStepConfig[] = [
    {
      key: StepKey.FIRST_STEP_0,
      scrollBehaviour: StepInitScrollBehaviour.SCROLL_TOP
    },
    {
      key: StepKey.FIRST_STEP_1,
      scrollBehaviour: this.isNext ? StepInitScrollBehaviour.SCROLL_TO_FIRST_SECTION : StepInitScrollBehaviour.SCROLL_TOP
    },
    {
      key: StepKey.FIRST_STEP_2,
      scrollBehaviour: this.isNext ? StepInitScrollBehaviour.SCROLL_TO_FIRST_SECTION : StepInitScrollBehaviour.SCROLL_TOP
    },
    {
      key: StepKey.FIRST_STEP_3,
      scrollBehaviour: this.isNext ? StepInitScrollBehaviour.SCROLL_TO_FIRST_SECTION : StepInitScrollBehaviour.SCROLL_TOP
    },
    {
      key: StepKey.SECOND_STEP,
      scrollBehaviour: StepInitScrollBehaviour.SCROLL_TOP
    },
    {
      key: StepKey.THIRD_STEP,
      scrollBehaviour: StepInitScrollBehaviour.SCROLL_TOP
    },
  ];

  constructor() { }

  shouldScrollToTop(stepKey): boolean {
    return this.getScrollBehaviour(stepKey) === StepInitScrollBehaviour.SCROLL_TOP;
  }

  shouldScrollToFirstSection(stepKey): boolean {
    return this.getScrollBehaviour(stepKey) === StepInitScrollBehaviour.SCROLL_TO_FIRST_SECTION;
  }

  private getScrollBehaviour(stepKey: string): StepInitScrollBehaviour {
    return this.getConfig(stepKey) ? this.getConfig(stepKey).scrollBehaviour : null;
  }

  private getConfig(stepKey: string): InternalStepConfig {
    return this.CONFIG.find(config => config.key === stepKey);
  }
}

export interface InternalStepConfig {
  key: string;
  scrollBehaviour: StepInitScrollBehaviour; // defines which scroll operation should be executed after step initialization
}

export enum StepInitScrollBehaviour {
  SCROLL_TOP = 'SCROLL_TOP', // scroll to top
  SCROLL_TO_FIRST_SECTION = 'SCROLL_TO_FIRST_SECTION', // restore original scroll position, then scroll to first section of given step
}
